import arrowIcon from 'assets/images/icons/arrows/arrow-right-white.png';
import Button from 'components/form/Button.component';
import InlineSpinner from 'components/generic/InlineSpinner.component';

import CN from './FormCard.module.scss';

export const FormCard = ({ header, footer, submitButtonLabel, isSubmitDisabled, isLoading, onSubmit, children }) => (
  <div data-bem="FormCard" className={CN.component}>
    {header && <div className={CN.header}>{header}</div>}

    <div className={CN.card}>
      <div className={CN.fields}>{children}</div>

      <Button variant="large" tag="FormCard__submit" className={CN.submitButton} disabled={isSubmitDisabled || isLoading} onClick={onSubmit}>
        <div>
          {isLoading ? (
            <InlineSpinner variant="light" />
          ) : (
            <span className={CN.submitButtonText}>
              {submitButtonLabel}
              <img src={arrowIcon} alt="" />
            </span>
          )}
        </div>
      </Button>

      {footer && <div className={CN.footer}>{footer}</div>}
    </div>
  </div>
);
